import { render, staticRenderFns } from "./moduleTwo.vue?vue&type=template&id=4cbface4"
import script from "./moduleTwo.vue?vue&type=script&lang=js"
export * from "./moduleTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports